import { render, staticRenderFns } from "./purchasingData.vue?vue&type=template&id=979decdc"
import script from "./purchasingData.vue?vue&type=script&lang=js"
export * from "./purchasingData.vue?vue&type=script&lang=js"
import style0 from "./purchasingData.vue?vue&type=style&index=0&id=979decdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports